import { Box } from "@mui/material";

export function RaiseHandAssistModal(props) {
  return (
    <Box>
      <h1>Modal</h1>
    </Box>
  );
}
